import { jsx as _jsx } from "react/jsx-runtime";
import Facebook from "@icons/Facebook";
import Instagram from "@icons/Instagram";
import Twitter from "@icons/Twitter";
import Youtube from "@icons/Youtube";
import LinkedIn from "@icons/LinkedIn";
const FooterSocialLinks = ({ links }) => {
    const getIconByType = ({ iconType, customIcon }) => {
        if (iconType === "facebook") {
            return _jsx(Facebook, {});
        }
        else if (iconType === "instagram") {
            return _jsx(Instagram, {});
        }
        else if (iconType === "twitter") {
            return _jsx(Twitter, {});
        }
        else if (iconType === "youtube") {
            return _jsx(Youtube, {});
        }
        else if (iconType === "linkedin") {
            return _jsx(LinkedIn, {});
        }
        else if (iconType === "custom") {
            return _jsx("div", { className: "custom-icon__container group", dangerouslySetInnerHTML: { __html: customIcon } });
        }
    };
    return (_jsx("div", { className: "footer__social-icons", children: _jsx("ul", { className: "footer__social-menu", children: links.map((link, i) => (_jsx("li", { className: "footer__social-item", children: _jsx("a", { className: "footer__social-link", href: link.url, target: "_blank", children: getIconByType(link) }) }, i))) }) }));
};
export default FooterSocialLinks;
